module.exports = __webpack_public_path__ + "img/1-8286.7e6c774e.png";